<template>
    <div class="product-page">
        <div class="main-container header-section">
            <div class="header-top">
                <h1 class="brand-title">HISTORICAL ORDERS</h1>
            </div>
            <div class="filter-bar"></div>
        </div>
        <div class="main-container content-section main_null" v-show="total == 0">PLEASE CONTINUE BROWSING</div>
        <OrderInfo :visible="visible" @closeHandler="handleClose" :orderId="orderId" />
        <div class="main-container content-section"
            v-show="total > 0 && tableData && tableData.length > 0 && screenWidth > 768">
            <el-row class="tab_head">
                <el-col v-for="item in headList" :key="item.name" :xs="item.minNum" :sm="item.maxNum">
                    <div class="tab_item">{{ item.name }}</div>
                </el-col>
            </el-row>
            <el-row class="tab_content" v-for="(item, index) in tableData" :key="index">
                <el-col :xs="4">
                    {{ item.orderSn }}
                </el-col>
                <el-col :xs="4">
                    {{ item.productCount }}
                </el-col>
                <el-col :xs="4">
                    $ {{ item.totalAmount }}
                </el-col>
                <el-col :xs="4">
                    {{ item.createDate }}
                </el-col>
                <el-col :xs="4">
                    {{ StatusList[item.status] }}
                </el-col>
                <el-col :xs="4" class="operation-col">
                    <div @click="handleOrderInfo(item)">DETAILS</div>
                    <!-- <div @click="delOrder(item)" style="margin-left: 10px;" v-if="item.status == 3">DELETE</div> -->
                </el-col>
            </el-row>
        </div>
        <div class="main-container content-section"
            v-show="total > 0 && tableData && tableData.length > 0 && screenWidth <= 768">
            <div class="tab_main"  v-for="(item, index) in tableData" :key="index">
                <div class="tab_item">
                    <strong style="color: #000;font-size: 4.5rem;">{{ item.orderSn }}</strong>
                    <span>{{ item.createDate }}</span>
                </div>
                <div class="tab_item">
                    <span>Quantity:{{ item.productCount }}</span>
                    <span> $ {{ item.totalAmount }}</span>
                </div>
                <div class="tab_item">
                    <span> {{ StatusList[item.status] }}</span>
                      <div @click="handleOrderInfo(item)">DETAILS</div>
                </div>  
            </div>
        </div>

        <div class="pagination-section" v-show="total > 0 && tableData && tableData.length > 0">
            <el-pagination layout="prev, pager, next, slot" :total="total" :current-page.sync="pageNo"
                prev-text="< Previous" next-text="Next >" @current-change="getList">
            </el-pagination>
        </div>
    </div>
</template>


<script>
import '@/style/address.scss'
import { orderPojoList, orderDelete } from '@/api/member'
import OrderInfo from '@/components/orderInfo.vue'
import { mapGetters } from "vuex";

export default {
    components: {
        OrderInfo
    },
    data() {
        return {
            StatusList: ['Order pending review', 'In production', 'Order shipped', 'Invalid Order'],
            visible: false,
            headList: [
                { name: 'Order', maxNum: 4 },
                { name: 'Quantity', maxNum: 4 },
                { name: 'Total', maxNum: 4 },
                { name: 'Date', maxNum: 4 },
                { name: 'Status', maxNum: 4 },
                { name: 'Operation', maxNum: 4 }],
            tableData: [],
            pageNo: 1,
            total: 0,
            orderId: ''
        };
    },
    activated() {
        this.getList(1);
    },
    computed: {
        ...mapGetters("app", ["getScreenWidth", "isMobile"]),
        screenWidth() {
            return this.getScreenWidth;
        },
    },
    methods: {
        delOrder(data) {
            this.$confirm('Are you sure to delete this order?', 'Warning', {
                confirmButtonText: 'Confirm',
                cancelButtonText: 'Cancel',
                type: 'warning',
                confirmButtonClass: 'ExitConfirmButton',
                cancelButtonClass: 'ExitCancelButton',
            }).then(() => {
                orderDelete({ orderId: data.orderId }).then(res => {
                    if (res.code == 1) {
                        this.getList(this.pageNo)
                        this.$message({
                            type: 'success',
                            message: 'Delete completed'
                        });
                    } else {
                        this.$message({
                            type: 'error',
                            message: res.message
                        });
                    }
                })

            });
        },
        handleClose() {
            this.visible = false
        },
        async getList(pageNo) {
            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(255, 255, 255, 0.8)'
            });
            this.pageNo = pageNo ? pageNo : this.pageNo
            const res = await orderPojoList({
                pageNo: this.pageNo,
            })
            if (res.code == 1) {
                this.tableData = res.data.dataList
                this.total = res.data.count
                if (this.pageNo > 1 && this.tableData.length === 0) {
                    this.pageNo--;
                    this.getList(this.pageNo);
                }
            }
            setTimeout(() => {
                loading.close();
            }, 200);
        },
        handleOrderInfo(data) {
            this.visible = true
            this.orderId = data.orderId
        },
    }
};
</script>

<style lang="scss" scoped>
.pagination-section {
    text-align: center;
    margin-top: 60px;

    ::v-deep .el-pagination {
        font-family: $serif-font;
        font-weight: normal;

        .btn-prev,
        .btn-next {
            background-color: transparent;
            color: #666;
            height: 32px;

            span {
                font-size: 14px;
            }
        }

        .el-pager li {
            background-color: transparent;
            color: #999;
            font-weight: normal;
            font-size: 14px;
            height: 32px;
            line-height: 32px;

            &.active {
                color: #000;
                font-weight: bold;
            }

            &:hover {
                color: #000;
            }
        }
    }
}
</style>